import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { ReactQueryDevtools } from '@tanstack/react-query-devtools';

export type QueryProviderProps = {
  children: React.ReactNode;
};
export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      retry: (failureCount, error) => {
        const nonRetryableErrorCodes = [400, 401, 404];
        const e = error as any;
        if (nonRetryableErrorCodes.includes(e?.response?.status)) {
          return false;
        }

        return failureCount < 3;
      },
    },
  },
});
export const QueryProvider = ({ children }: QueryProviderProps) => (
  <QueryClientProvider client={queryClient}>
    <ReactQueryDevtools initialIsOpen={false} />
    {children}
  </QueryClientProvider>
);
